var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHr2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6055 11.0417C23.2128 11.0417 19.0001 12.7867 15.894 15.8928C12.7879 18.9989 11.043 23.2116 11.043 27.6042C11.043 31.9969 12.7879 36.2096 15.894 39.3157C19.0001 42.4218 23.2128 44.1667 27.6055 44.1667C31.9981 44.1667 36.2109 42.4218 39.3169 39.3157C42.423 36.2096 44.168 31.9969 44.168 27.6042C44.168 23.2116 42.423 18.9989 39.3169 15.8928C36.2109 12.7867 31.9981 11.0417 27.6055 11.0417ZM15.4596 22.0834H19.8763C20.462 22.0834 21.0237 22.3161 21.4378 22.7302C21.852 23.1444 22.0846 23.7061 22.0846 24.2917V26.5001C22.0846 27.6042 21.2455 28.4876 20.1855 28.6422L22.7692 33.1251H20.2076L17.668 28.7084V33.1251H15.4596M26.5013 22.0834H30.918V24.2917H26.5013V26.5001H30.918V28.7084H26.5013V30.9167H30.918V33.1251H26.5013C25.9156 33.1251 25.3539 32.8924 24.9398 32.4783C24.5256 32.0641 24.293 31.5024 24.293 30.9167V24.2917C24.293 23.7061 24.5256 23.1444 24.9398 22.7302C25.3539 22.3161 25.9156 22.0834 26.5013 22.0834ZM35.3346 22.0834H39.7513V24.2917H35.3346V30.9167H39.7513V33.1251H35.3346C34.7489 33.1251 34.1873 32.8924 33.7731 32.4783C33.359 32.0641 33.1263 31.5024 33.1263 30.9167V24.2917C33.1263 23.7061 33.359 23.1444 33.7731 22.7302C34.1873 22.3161 34.7489 22.0834 35.3346 22.0834ZM17.668 24.2917V26.5001H19.8763V24.2917",
    fill: "url(#paint0_linear_1714_4834)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_4834",
    x1: 11.043,
    y1: 6.90112,
    x2: 46.3559,
    y2: 45.5791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EB5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHr2);
export default __webpack_public_path__ + "static/media/Hr2.a8fb58782d9bcff285bf26cac5b27610.svg";
export { ForwardRef as ReactComponent };